import { endpoint } from '@/common/constants'
import resource from '@/api/resource'

export default {
  /**
   * @description Mint the Webchat V2 session for the signed-in dashboard user.
   * POST with no body (hub-service `webchat_v2/resources/dashboard_sessions.rb`).
   * The response carries a bearer: never log it or keep it in the store.
   * @returns {Promise}
   */
  createDashboardSession() {
    return resource.post(endpoint.v1.webchatV2.dashboardSession)
  },
}
